import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledInstagramStoryItem = styled('div')(
  () => css`
    .story-item {
      max-width: max-content;

      .story-image {
        position: relative;
        overflow: hidden;
        border-radius: 16px;
        border: 1px solid #eeeeee;
        box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24),
          0px 3px 8px -1px rgba(50, 50, 71, 0.05);
        width: 170px;
        height: 302px;
        display: flex;
        background-color: #111111;
        cursor: pointer;

        img,
        video {
          max-width: 100%;
          display: block;
          object-fit: contain;
          pointer-events: none;
        }

        .MuiCheckbox-root {
          position: absolute;
          z-index: 1;

          .MuiSvgIcon-root {
            fill: #ffffff;
          }
        }

        .story-image-header {
          box-sizing: border-box;
          background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 100%);
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: flex-end;
          padding: 8px;
          gap: 8px;
          width: 100%;
          min-height: 48px;

          .header-username {
            color: #f9f9f9;
            font-size: 0.63rem;
            font-weight: 400;
            line-height: 1rem;
            direction: ltr;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .header-avatar,
          .header-avatar-text {
            min-width: 24px;
            max-width: 24px;
            min-height: 24px;
            max-height: 24px;
            border-radius: 6px;
            border: 1px solid #edf2f7;
            box-shadow: 0px 3px 8px rgba(50, 50, 71, 0.05);
          }

          .header-avatar-text {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }

      .story-datetime {
        display: flex;
        justify-content: center;
        min-height: 40px;

        .date-container {
          margin-left: 0;
        }
      }
    }
  `
);
